import React from 'react'

import ConfirmationContainer from '../../components/buy/confirmation/ConfirmationContainer'
import ConfirmationMarketingContent from '../../components/buy/confirmation/ConfirmationMarketingContent'
import CartItemsSummary from '../../components/buy/summary/CartItemsSummary'
import { OrderSummary } from '../../components/buy/summary/OrderSummary'
import { SanityCheckoutMarketingContentFragment } from '../../graphql/gatsby'
import { CartFragment } from '../../graphql/magento'
import LeftHalfLayout from './LeftHalfLayout'
import RightHalfLayout from './RightHalfLayout'

export interface ConfirmationLayoutProps {
  className?: string
  cart: CartFragment
  checkoutMarketingContent: SanityCheckoutMarketingContentFragment['sanityCheckoutMarketingContent']
}

const ConfirmationLayout: React.FC<ConfirmationLayoutProps> = ({
  children,
  cart,
  className,
  checkoutMarketingContent,
}) => {
  return (
    <ConfirmationContainer className={className}>
      <LeftHalfLayout>{children}</LeftHalfLayout>
      <RightHalfLayout>
        <OrderSummary cart={cart} totalConfirmed />
        <CartItemsSummary cart={cart} orderConfirmed />
      </RightHalfLayout>
      <ConfirmationMarketingContent checkoutMarketingContent={checkoutMarketingContent} />
    </ConfirmationContainer>
  )
}

export default ConfirmationLayout
